/** https://tailwindcss.com/docs/screens */
export const breakpoints = {
  xs: 420,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const

export function matchMinBreakpoint(breakpoint: keyof typeof breakpoints) {
  return matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`)
}
